"use client"

import { createContext, useContext, useEffect, useState } from "react"

export type Role =
  | "usuario"
  | "dj"
  | "residente"
  | "editor"
  | "admin"

export type Usuario = {
  id: string
  email: string
  displayName: string
  password: string        // ← NECESARIO para login local
  avatar?: string
  role: Role
  createdAt: string
}

type AuthContextType = {
  user: Usuario | null
  loading: boolean
  isAuthenticated: boolean
  login: (email: string, password: string) => boolean
  logout: () => void
  updateUser: (data: Partial<Usuario>) => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<Usuario | null>(null)
  const [loading, setLoading] = useState(true)

  // CARGA INICIAL
  useEffect(() => {
    const stored = localStorage.getItem("mixtape:user")
    if (stored) {
      setUser(JSON.parse(stored))
    }
    setLoading(false)
  }, [])

  // LOGIN LOCAL (email + password)
  const login = (email: string, password: string): boolean => {
    const storedUsers = localStorage.getItem("mixtape:usuarios")
    const users: Usuario[] = storedUsers ? JSON.parse(storedUsers) : []

    const found = users.find(
      (u) => u.email === email && u.password === password
    )

    if (!found) return false

    setUser(found)
    localStorage.setItem("mixtape:user", JSON.stringify(found))
    return true
  }

  // LOGOUT
  const logout = () => {
    setUser(null)
    localStorage.removeItem("mixtape:user")
  }

  // UPDATE USER
  const updateUser = (data: Partial<Usuario>) => {
    if (!user) return

    const updated = { ...user, ...data }
    setUser(updated)
    localStorage.setItem("mixtape:user", JSON.stringify(updated))
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated: !!user,
        login,
        logout,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error("useAuth debe usarse dentro de AuthProvider")
  return ctx
}
